<template>
    <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
            Delete target for {{ candidate.object }}
        </v-card-title>

        <v-card-text class="mt-5">
            If the target has observations scheduled, they will be only accesible through the observatory site.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="primary"  @click="closeDelete">Cancel</v-btn>
            <v-btn small color="error"  @click="onDelete">Delete</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: "DeleteTarget",
    props: ["candidate", "show"],
    data() {
        return {
        };
    },
    methods: {
        closeDelete() {
            this.$emit('update:show', false);
        },
        onDelete() {
            this.$tomapi.delete_target(this.candidate.target_id).then(() =>{
                this.$emit('update:candidate', {});
                this.closeDelete();
            }).catch(error => {
                alert(error);
            });
        }
    }
};
</script>